import React, { useMemo } from 'react';
import Modal from '../Modal';
import { observer } from 'mobx-react';
import Row, { RowBetween } from 'components/Row';
import Button from 'components/Button';

import { formatHashValue } from 'utils';

import { WalletTokenInfo } from '../../constant';
import styled from 'styled-components';
import { TYPE } from 'theme';
import makeBlockie from 'ethereum-blockies-base64';
import { useAccount, useDisconnect } from 'wagmi';
import user from 'stores/user';
import { MetisLogo } from 'common-helpers/img';
import { AutoColumn } from 'components/Column';
import TokenInfo from './TokenInfo';
import { useAccountModal } from '@rainbow-me/rainbowkit';
import Copy from 'components/Copy';
import { invitePath } from 'constant/route-path';
import { useHistory, useLocation } from 'react-router-dom';
import { clearToken } from 'utils/auth';

const Wrapper = styled.div`
    width: 100%;
    box-sizing: border-box;
    /* padding: 20px; */
`;

const StyledCopy = styled(Copy)`
    margin-left: 4px;
    width: 16px;
    height: 16px;
`;

const Content = styled.div`
    box-sizing: border-box;
    padding: 20px;
    margin-top: 20px;

    .changeButton {
        padding: 6px 12px;
        margin-left: 8px;
        border-radius: 6px;
        font-size: 14px;
    }

    .logo {
        width: 32px;
        height: 32px;
        margin-right: 10px;
        border-radius: 16px;
    }

    .bottom {
        margin-top: 20px;
    }

    ${({ theme }) => theme.mediaWidth.upToSmall`
     .bottom {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .funcWrapper {
            margin-bottom: 16px;
        }
     }
    `}
`;

const TokenAmountWrapper = styled.div`
    margin-top: 25px;
    border-top: 1px solid #cfcfcf;
    padding-top: 25px;
`;

const TokenList = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    gap: 20px;
    margin-top: 20px;
`;

interface Props {
    isOpen: boolean;
    onClose: () => void;
}
function AccountDetail({ isOpen, onClose }: Props) {
    const { connected, address: walletAddress } = user;
    const { disconnect } = useDisconnect();
    const { connector } = useAccount();
    const { openAccountModal } = useAccountModal();
    const history = useHistory();
    const location = useLocation();

    async function handleChangeAccount() {
        await disconnect();
        clearToken();
        onClose();
        history.push({ pathname: invitePath, search: location.search });
    }

    const walleTokens = useMemo(() => {
        return WalletTokenInfo[user.chainId];
    }, [user.chainId]);

    if (!connected) return null;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            shadowProps={true}
            // customContentClass={style.accountContainer}
        >
            <Wrapper>
                <Row>
                    <TYPE.main fontSize={20}>Wallet</TYPE.main>
                </Row>
                <Content>
                    <RowBetween lineHeight="none">
                        <Row>
                            <img
                                src={walletAddress ? makeBlockie(walletAddress) : MetisLogo}
                                alt=""
                                className={'logo'}
                            />
                            <AutoColumn gap="4px">
                                <TYPE.main>{connector?.name}</TYPE.main>
                                <Row>
                                    <TYPE.desc
                                        fontSize={14}
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                            if (openAccountModal) {
                                                openAccountModal();
                                                onClose();
                                            }
                                            // window.open(
                                            //     `${
                                            //         NETWORK_CONFIG[user.chainId]
                                            //             ?.explore
                                            //     }address/${walletAddress}`,
                                            // );
                                        }}
                                    >
                                        {formatHashValue(walletAddress)}
                                    </TYPE.desc>
                                    <StyledCopy text={walletAddress} />
                                </Row>
                            </AutoColumn>
                        </Row>
                        <Button size="small" className={'changeButton'} onClick={handleChangeAccount}>
                            Disconnect
                        </Button>
                    </RowBetween>
                    <TokenAmountWrapper style={{ border: 'none', paddingTop: 0 }}>
                        <RowBetween>
                            <TYPE.desc>TOKEN</TYPE.desc>
                            <TYPE.desc>Balance</TYPE.desc>
                        </RowBetween>
                        <TokenList>
                            {walleTokens.map((item) => (
                                <TokenInfo
                                    key={item.address}
                                    logo={<item.logo />}
                                    address={item.address}
                                    name={item.name}
                                />
                            ))}
                        </TokenList>
                    </TokenAmountWrapper>
                </Content>
            </Wrapper>
        </Modal>
    );
}

export default observer(AccountDetail);
